import "./breadcrumb.scss";
import { useNavigate } from "react-router-dom";

export interface IBreadcrumbItem {
  name: string;
  url?: string;
}

interface IBreadcrumbProps {
  breadCrumbItems: IBreadcrumbItem[];
}

const Breadcrumb = ({
  breadCrumbItems
}: IBreadcrumbProps) => {
  const navigate = useNavigate();

  return (
    <div className='breadcrumb'>
      {breadCrumbItems.map((item, i) => {
        return (
          <div className='breadcrumb-items' key={i}>
            <span
              onClick={() => item.url && navigate(item.url)} 
              className="breadcrumb-option"
            >
              {item.name}
            </span>
            {i < breadCrumbItems.length - 1 && (
              <span className="breadcrumb-optionDelimiter">-</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumb;